import createLucideIcon from '../createLucideIcon';

const CornerDownLeft = createLucideIcon('CornerDownLeft', [
  ['polyline', { points: '9 10 4 15 9 20', key: 'r3jprv' }],
  ['path', { d: 'M20 4v7a4 4 0 0 1-4 4H4', key: '6o5b7l' }],
]);

export default CornerDownLeft;
